import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { ThemeProvider } from './theme/ThemeProvider';
import { ensureAntiforgeryToken } from './api';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Snippets are edited by one person in one tab far more often than not, so aggressive
      // refetching mostly costs requests.
      refetchOnWindowFocus: false,
      staleTime: 10_000,
      retry: 1,
    },
  },
});

const root = document.getElementById('root');
if (!root) {
  throw new Error('No #root element to mount into.');
}

// Fetch an antiforgery token before the first write can be attempted.
void ensureAntiforgeryToken();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
